module.exports = __webpack_public_path__ + "img/H@2x.34b0f386.jpg";